import { SolutionSpace } from 'src/app/models/solution';
import { Layout } from 'src/app/services/breakpoints';
import { TableColumn } from 'src/app/shared/table/table.component';

// The status dot beside the ID and the project column are part of the row identity, so every set keeps them.
const always = ['componentIconHealth', 'componentId', 'isCurrentlyInProject'];

const phoneKeys: Record<SolutionSpace, ReadonlySet<string>> = {
  [SolutionSpace.Utilization]: new Set([...always, 'utilization', 'daysInState', 'lastCommunication', 'batteryLevel']),
  [SolutionSpace.Humidity]: new Set([...always, 'humidity', 'temperature', 'lastCommunication', 'batteryLevel']),
};

// positionType is the position icon that sits beside Country, so it appears with it.
const tabletKeys: Record<SolutionSpace, ReadonlySet<string>> = {
  [SolutionSpace.Utilization]: new Set([
    ...always,
    'positionType',
    'countryName',
    'placeName',
    'utilization',
    'daysInState',
    'lastCommunication',
    'batteryLevel',
  ]),
  [SolutionSpace.Humidity]: new Set([
    ...always,
    'humidity',
    'temperature',
    'positionType',
    'countryName',
    'placeName',
    'lastCommunication',
    'batteryLevel',
  ]),
};

/** The columns to show at this screen size, in their original order. Desktop shows the list as given. */
export function columnsForLayout(columns: TableColumn[], layout: Layout, solution: SolutionSpace): TableColumn[] {
  if (layout === 'desktop') {
    return columns;
  }
  const keys = layout === 'phone' ? phoneKeys[solution] : tabletKeys[solution];
  return columns.filter(({ key }) => keys.has(key));
}
